import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import determinarPaginaAtual from '../../actions/rota-itinerario/determinarPaginaAtualRotaItinerario'
import alterarRegistrosPorPagina from '../../actions/rota-itinerario/alterarRegistrosPorPaginasRotaItinerario'

export class PaginacaoDisponiveisInternet extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtual,
    alterarRegistrosPorPagina
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualRotaItinerario,
    total: state.rotasItinerario.total,
    registrosPorPagina: state.registrosPorPaginaRotaItinerario
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoDisponiveisInternet)
